import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { ReactNode, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import RouterConstants from "../../../constants/RouterConstants";
import BriaButton from "../../common/BriaButton/BriaButton";
import BriaButtonGroup from "../../common/BriaButtonGroup/BriaButtonGroup";
import CopyApiTokenButton from "../../common/OverviewFooter/CopyApiTokenButton";
import styles from "./ConsoleAPILayout.module.scss";

interface Props {
	description?: string;
	hideCopyTokenBtn?: boolean;
	children: ReactNode;
	className?: string;
	showVideoLabButton?: boolean;
	rightActions?: ReactNode;
	showIntegrationKeyButton?: boolean;
	descriptionClassName?: string;
}

const ConsoleAPILayout = ({
	description,
	hideCopyTokenBtn = false,
	children,
	className,
	showVideoLabButton = false,
	rightActions,
	showIntegrationKeyButton = false,
	descriptionClassName,
}: Props) => {
	const { t } = useTranslation("translation");
	const navigate = useNavigate();
	useEffect(() => {
		if (window.location.hash === "#automotive") {
			const contentDiv = document.getElementById("content");
			if (contentDiv) {
				setTimeout(() => {
					contentDiv.scrollTo({
						top: contentDiv.scrollHeight,
						behavior: "smooth",
					});
				}, 100);
			}
		}
	}, []);

	return (
		<Box className={`${styles.container} ${className || ""}`}>
			<Box className={styles.header}>
				<Trans>
					<Typography className={clsx(styles.description, descriptionClassName)}>{description}</Typography>
				</Trans>
				{showVideoLabButton ? (
					<Box className={styles.buttonsContainer}>
						<BriaButton
							buttonType="primary"
							className={styles.button}
							onClick={() => {
								window.open(RouterConstants.LABS.VIDEO_EDITING.fullPath, "_blank");
							}}
						>
							{t("videoEditingLab")}
						</BriaButton>
						{((!hideCopyTokenBtn && !showIntegrationKeyButton) ||
							rightActions ||
							showIntegrationKeyButton) && (
							<BriaButtonGroup>
								{showIntegrationKeyButton ? (
									<BriaButton
										buttonType="primaryMedium"
										onClick={() => navigate(RouterConstants.AUTH_KEYS.fullPath)}
									>
										{t("takeIntegrationKey")}
									</BriaButton>
								) : (
									!hideCopyTokenBtn && <CopyApiTokenButton />
								)}
								{rightActions}
							</BriaButtonGroup>
						)}
					</Box>
				) : (
					((!hideCopyTokenBtn && !showIntegrationKeyButton) || rightActions || showIntegrationKeyButton) && (
						<BriaButtonGroup>
							{showIntegrationKeyButton ? (
								<BriaButton
									buttonType="primaryMedium"
									onClick={() => navigate(RouterConstants.AUTH_KEYS.fullPath)}
								>
									{t("takeIntegrationKey")}
								</BriaButton>
							) : (
								!hideCopyTokenBtn && <CopyApiTokenButton />
							)}
							{rightActions}
						</BriaButtonGroup>
					)
				)}
			</Box>

			<Box className={styles.content} id="content">
				{children}
			</Box>
		</Box>
	);
};

export default ConsoleAPILayout;
